import './_autocomplete-search-input.scss';
import component from './autocomplete-search-input';

export default component;
